import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {
  OrderType,
  SupplierPluginsNames,
  UserPayers,
  UserSuppliers,
  UserSuppliersAndOutlets
} from "../../../app-shared/models/supplier-outlet.model";
import {SupplierOutletService} from "../../../app-shared/services/supplier-outlet.service";
import {ObjectForeSearch} from "../../../catalog/models/search.model";
import {Router} from "@angular/router";
import {CartService} from "../../../app-shared/services/cart.service";
import {CatalogService} from "../../../catalog/catalog.service";
import {SearchService} from "../../../app-shared/services/search-service";
import {PriorityListType} from "../../../catalog/models/product.model";
import {Subject} from "rxjs";
import {BreadCrumbsDynamicService} from "../../../app-shared/services/bread-crumbs.service";
import {takeUntil} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "src/environments/environment";

@Component({
    selector: 'app-change-outlet',
    templateUrl: './change-outlet.component.html',
    standalone: false
})
export class ChangeOutletComponent implements OnInit {
  @Input() mobile: boolean;
  @Input() isLoginSuperBusinessAdminOrBusinessAdmin: boolean;
  @Output() closeAction = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(){

  }
  customComponentForChangeOutlet() {
    if(!!environment['customComponentForChangeOutlet']){} {
      return environment['customComponentForChangeOutlet'];
    }
    return null;
  }

}
